import axios from 'axios';
import Cookies from 'js-cookie';

export function windowLocationBaseUrl() {
  return [window.location.protocol, '//', window.location.host].join('');
}

export const createDataUrlEncoded = (object) => {
  const formData = [];
  Object.keys(object).forEach((key) => {
    formData.push(
      `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`,
    );
  });
  return formData.join('&');
};

export const generateRandomId = (length = 24) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  let str = '';
  for (let i = 0; i < length; i += 1) {
    str += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return str;
};

export const normalizedLanguage = (_lang) => {
  // If the language is coming in the format en_GB returns it as it is, because is already according to the api format.
  if (_lang.length > 3) return _lang;

  const lang = _lang.toLowerCase();
  if (lang === 'en') return lang.concat('_', 'GB');
  if (lang === 'es') return lang.concat('_', 'ES');
  if (lang === 'it') return lang.concat('_', 'IT');
  if (lang === 'de') return lang.concat('_', 'DE');
  if (lang === 'ro') return lang.concat('_', 'RO');
  if (lang === 'ca') return 'es_CA';

  return null;
};

export const getLanguage = () => {
  const language = Cookies.get('i18next').replace('-', '_');

  return language;
};

export const getCountry = () => {
  const country = Cookies.get('i18next').split('-')[1];

  return country;
};
